import React, { useState, useEffect } from "react";
import { Document, Page } from "react-pdf";

const PdfComponent = ({ pdf }) => {
  const [numPages, setNumPages] = useState(null);
  const [pdfBlobUrl, setPdfBlobUrl] = useState(null);
  const [error, setError] = useState(null);
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const controller = new AbortController();
    let blobUrl;

    setPdfBlobUrl(null);
    setNumPages(null);
    setError(null);

    const fetchPdf = async () => {
      try {
        const response = await fetch(pdf, { signal: controller.signal });
        if (!response.ok) {
          throw new Error(`Failed to fetch PDF. Status: ${response.status}`);
        }

        const blob = await response.blob();
        blobUrl = URL.createObjectURL(blob);
        setPdfBlobUrl(blobUrl);
      } catch (err) {
        if (err.name === "AbortError") return;
        console.error(err);
        setError("Failed to load PDF. Please try again later.");
      }
    };

    fetchPdf();

    return () => {
      controller.abort();
      if (blobUrl) URL.revokeObjectURL(blobUrl);
    };
  }, [pdf]);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const zoomIn = () => setScale((s) => Math.min(s + 0.1, 2));
  const zoomOut = () => setScale((s) => Math.max(s - 0.2, 0.2));
  const resetZoom = () => setScale(1);
  const onDocumentLoadError = (loadError) => {
    console.error("Error rendering PDF", loadError);
    setError("Failed to display PDF. Please try again later.");
  };

  if (error) return <div>{error}</div>;

  return (
    <div className="hlwtest">
      <div className="flex gap-2 mb-2 justify-end">
        <button onClick={zoomOut} className="px-3 py-1 bg-gray-200 rounded">-</button>
        <span className="text-sm">{Math.round(scale * 100)}%</span>
        <button onClick={zoomIn} className="px-3 py-1 bg-gray-200 rounded">+</button>
        <button onClick={resetZoom} className="px-2 py-1 bg-gray-200 rounded text-xs">
          Reset
        </button>
      </div>

      {pdfBlobUrl ? (
        <Document
          file={pdfBlobUrl}
          onLoadSuccess={onDocumentLoadSuccess}
          onLoadError={onDocumentLoadError}
          className="pdf-document-container"
        >
          {Array.from({ length: numPages || 0 }, (_, i) => (
            <Page
              key={`page_${i + 1}`}
              pageNumber={i + 1}
              scale={scale}
              renderTextLayer={false}
              renderAnnotationLayer={false}
            />
          ))}
        </Document>
      ) : (
        <div>Loading PDF...</div>
      )}
    </div>
  );
};

export default PdfComponent;
